var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lista-tiendas-mobile"},_vm._l((_vm.tiendas),function(tienda,i){return _c('TiendaCard',{key:("tienda_" + i),attrs:{"tienda":tienda}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }